import { Component, effect, inject, model, OnInit } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  lucideTag,
  lucidePenLine,
  lucideTrash2,
} from '@ng-icons/lucide';

import { CategoryFormComponent } from '../category-form/category-form.component';
import { CrudService } from '../../core/services/crud.service';

@Component({
  selector: 'app-category-list',
  imports: [NgIcon, CategoryFormComponent],
  viewProviders: [provideIcons({ lucideTag, lucidePenLine, lucideTrash2 })],
  templateUrl: './category-list.component.html',
})
export class CategoryListComponent implements OnInit {
  private crudService = inject(CrudService);
  categories: Array<any> = [];

  existingCategory: any;

  showModal = model(false);

  constructor() {
    effect(() => {
      if (!this.showModal()) {
        this.getCategories();
      }
    });
  }

  ngOnInit(): void {
    // this.getCategories();
  }

  openModal() {
    this.existingCategory = null;
    this.showModal.set(true);
  }

  getCategories() {
    this.crudService.getCategories().subscribe({
      next: (response: any) => {
        if (response.ok) {
          this.categories = response.body;
        }
      },
    });
  }

  updateCategory(category: any) {
    this.existingCategory = category;
    this.showModal.set(true);
  }

  deleteCategory(categoryId: number) {
    this.crudService.deleteCategory(categoryId).subscribe({
      next: (response: any) => {
        if (response.ok) {
          this.getCategories();
        }
      },
    });
  }
}
